var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 22.776V3.08c2.158-.06 6.875-.145 8.48 0 2.006.183 4.285 1.004 5.106 2.462.82 1.46 1.003 3.374.365 5.654-.51 1.823-2.887 2.766-4.011 3.009l5.105 8.57h-4.286L7.11 14.57H4.555v8.206H1zm15.318 5.562V8.643h3.1v1.823c.092-.212.53-.784 1.55-1.367 1.277-.73 2.918-.913 4.286-.822C26.622 8.369 31.09 10.1 31 15.39c-.093 5.288-3.922 6.656-6.749 6.93-2.26.219-3.98-1.246-4.558-2.006v8.024h-3.374zm11.216-13.13a4.012 4.012 0 1 1-8.024 0 4.012 4.012 0 0 1 8.024 0zM4.556 11.287V5.998H8.66l.278.03c1.054.105 2.738.273 2.821 2.523.083 2.254-1.69 2.522-2.808 2.69-.104.017-.202.031-.293.047H4.555z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdrt);
export default __webpack_public_path__ + "static/media/IDRT.ea2a11ec4662ca1be45e76c201634f20.svg";
export { ForwardRef as ReactComponent };